import axios from '@/app/axios'
import Stakeholder from '@/stakeholders/entities/stakeholder'
import Responses from '@/app/utils/responses'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import StakeholdersRequest from '@/stakeholders/requests/stakeholders-request'
import Project from '@/projects/entities/project'

class StakeholdersService {

  public async findAllAsync(request: StakeholdersRequest) {
    const res = await axios.post<PaginationResponse<Stakeholder>>('stakeholder', request)
    return Responses.pagedList(res)
  }

  public async findAllProjectsAsync(id: string) {
    const res = await axios.get<Project[]>(`stakeholder/projects?id=${id}`)
    return Responses.list(res)
  }

  public async createAsync(stakeholder: Stakeholder) {
    const res = await axios.post<Stakeholder>(`stakeholder/create`, stakeholder)
    return Responses.obj(res)
  }

  public async updateAsync(stakeholder: Stakeholder) {
    const res = await axios.put<Stakeholder>('stakeholder/update', stakeholder)
    return Responses.obj(res)
  }

  public async deleteAsync(stakeholder: Stakeholder) {
    const res = await axios.post<Stakeholder>(`stakeholder/${stakeholder.id}/delete`)
  }

  public async findRoles(search: string) {
    const res = await axios.get<string[]>(`stakeholder/roles?search=${search}`)
    return Responses.list(res)
  }
}

export default new StakeholdersService()
